import { render, staticRenderFns } from "./ResultUserInfo.vue?vue&type=template&id=46ff7e41&scoped=true"
import script from "./ResultUserInfo.vue?vue&type=script&lang=js"
export * from "./ResultUserInfo.vue?vue&type=script&lang=js"
import style0 from "./ResultUserInfo.vue?vue&type=style&index=0&id=46ff7e41&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ff7e41",
  null
  
)

export default component.exports